function addFreeShippingMessage() {
  const freeShipping = document.getElementById("cart-progress-unlocked");

  if (!freeShipping) return;

  if (document.getElementById("free-shipping-message")) return;

  freeShipping.insertAdjacentHTML(
    "afterend",
    `
      <div id="free-shipping-message" class="free-shipping-message">
        🚚 <strong>DOUBLE UP & GET FREE SHIPPING!</strong>
      </div>
    `
  );
}

const interval = setInterval(() => {
  if (document.getElementById("cart-progress-unlocked")) {
    addFreeShippingMessage();
    clearInterval(interval);
  }
}, 300);

// Your order qualifies for FREE shipping. 